import { unityPropsContext } from 'components/UnityPropsContext'
import React, { FC, ReactElement } from 'react'
import styled from 'styled-components'
import { device } from '../breakpoints'
// import DepthMapParallax from 'components/DepthMapParallax'

interface Props {
  title: ReactElement
  lead: string
  keywords: string
  tenant: MicroFrontendProps['tenant']
}
const Header: FC<Props> = ({ keywords, title, lead, tenant }): ReactElement => {
  return (
    <>
      <Container>
        {/* <DepthMapParallax /> */}
        <TextContainer>
          <TextWidth>
            <TitleContainer>
              <Sup>{keywords}</Sup>
              <Title>{title}</Title>
            </TitleContainer>
            <Text>{lead}</Text>
            <Authors>
              <strong>
                {tenant && tenant.lang === 'de'
                  ? 'Yannick Wiget, Fanny Giroud, Mathieu Rudaz'
                  : 'Fanny Giroud, Mathieu Rudaz'}
              </strong>
            </Authors>
            <Date>
              <>
                {tenant.lang === 'de'
                  ? 'Publiziert am 6. Mai 2023'
                  : 'Mis à jour le 16 avril 2023'}
              </>
            </Date>
          </TextWidth>
        </TextContainer>
      </Container>
      <Legend>
        {tenant.lang === 'de'
          ? 'Illustrationen: MR / generiert mit Hilfe künstlicher Intelligenz: Midjourney.'
          : 'Illustrations: MR / générées avec l’intelligence artificielle Midjourney.'}
      </Legend>
    </>
  )
}

const TextContainer = styled.div`
  position: absolute;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  overflow: hidden;
  pointer-events: none;
`

const TextWidth = styled.div`
  max-width: 600px;
  // margin-bottom: 5%;
  color: white;
  text-align: left;

  @media ${device.mobileS}, @media ${device.mobileM}, @media ${device.mobileL} {
    padding: 0 30px;
    margin-left: 1em;
  }

  @media ${device.tablet}, @media ${device.laptop} {
    padding: 0;
    margin-left: 10vw;
  }
`

const Container = styled.div`
  position: relative;
  text-align: left;
  z-index: 1;
  width: calc(100vw + 2em);
  height: 100vh;
  background-size: cover;
  margin-bottom: 10px;
  margin-left: -1em;
  margin-top: -1em;

  @media ${device.mobileS}, @media ${device.mobileM}, @media ${device.mobileL} {
    background-position: 40% center;
    background-image: url(${require(`../../Assets/images/heritage-mobile.jpg`)});
  }

  @media ${device.tablet}, @media ${device.laptop} {
    background-position: center;
    background-image: url(${require(`../../Assets/images/heritage-b.jpg`)});
    margin-top: -30px;
    height: calc(100vh + 30px);
  }

  &:before {
    content: '';
    background-color: #141b2f33;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
`

const TitleContainer = styled.h2`
  margin-top: 0;

  @media ${device.mobileS}, @media ${device.mobileM}, @media ${device.mobileL} {
    margin-bottom: 1.2rem;
    font-size: 3.6rem;
    line-height: 4rem;
  }

  @media ${device.tablet}, @media ${device.laptop} {
    margin-bottom: 1.2rem;
    font-size: 7rem;
    line-height: 1;
  }
`

const Title = styled.span`
  font-family: var(--font-source);
  font-weight: 600;
  display: block;
`

const Text = styled.h3`
  font-family: var(--font-sans-serif);
  font-weight: 400;
  -webkit-font-smoothing: antialiased;

  @media ${device.mobileS}, @media ${device.mobileM}, @media ${device.mobileL} {
    font-size: 1.8rem;
    line-height: 2.7rem;
  }

  @media ${device.tablet}, @media ${device.laptop} {
    font-size: 2rem;
    line-height: 2.9rem;
  }
`

const Sup = styled.span`
  display: inline-block;
  min-width: 85%;
  margin-bottom: 0.8rem;
  font-size: 1.5rem;
  font-family: var(--font-sans-serif);
  line-height: 2rem;
  color: white;

  &:before {
    display: inline-block;
    margin-right: 0.6rem;
    padding: 0.2rem 0.6rem;
    color: var(--brandblue-main);
    font-weight: 700;
    font-size: 1.2rem;
    font-family: var(--font-sans-serif);
    line-height: 1.5rem;
    letter-spacing: 0.025rem;
    white-space: nowrap;
    background-color: white;
    content: 'Abo';
  }
`

const Authors = styled.div`
  font-family: var(--font-sans-serif);
  font-size: 1.2rem;
  line-height: 1.2;
  margin-bottom: 1rem;
`

const Link = styled.a`
  text-decoration: underline;
`

const Date = styled.div`
  font-size: 1.2rem;
  font-family: var(--font-sans-serif);
  opacity: 0.5;
  line-height: 1.2;
`

const Legend = styled.div`
  font-size: 1.2rem;
  opacity: 0.5;
  max-width: 669px;
  margin: 0 auto;
  margin-bottom: 6rem;
`

export default Header
